import React, { useEffect, useState } from 'react';
import { Alert, Button, Icon } from '../../components';
import { Section } from '../../layout';
import { getSession } from '../../api/Assinafy';
import { oauthApi } from '../../api/oauth';
import { AppIdentity, ScopeList, ConfirmAction } from './Shared';
import { errorMessage } from './utils';

export default function ConnectedApps() {
  const [grants, setGrants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [selected, setSelected] = useState(null);
  const [busy, setBusy] = useState(false);
  const [actionError, setActionError] = useState('');
  const [reload, setReload] = useState(0);
  const accounts = getSession().accounts || [];
  const workspaceName = id => accounts.find(account => account.id === id)?.name || (id ? `Workspace ${id}` : 'Workspace não disponível');
  useEffect(() => {
    let active = true;
    setLoading(true); setError('');
    oauthApi.grants().then(data => { if (active) setGrants(data); })
      .catch(err => { if (active) setError(errorMessage(err)); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [reload]);
  const revoke = async () => {
    if (busy) return;
    setBusy(true); setActionError('');
    try {
      await oauthApi.revoke(selected.id);
      setGrants(items => items.filter(item => item.id !== selected.id));
      setSelected(null);
    } catch (err) { setActionError(errorMessage(err)); }
    finally { setBusy(false); }
  };
  const groups = grants.reduce((result, grant) => {
    const key = grant.account_id || '';
    if (!result[key]) result[key] = [];
    result[key].push(grant);
    return result;
  }, {});
  return <Section className="oauth-section">
    <Section.Header title="Aplicativos com acesso à sua conta" titleAs="h3" opening="Confira as permissões concedidas em cada workspace e revogue o acesso quando quiser." />
    {loading ? <p role="status">Carregando aplicativos...</p> : error ? <><Alert variant="danger">{error}</Alert><Button variant="info" onClick={() => setReload(value => value + 1)}>Tentar novamente</Button></> : <>
      {!grants.length && <div className="oauth-empty"><span className="oauth-empty-icon"><Icon id="icon-verified_user" size="32" /></span><h3>Nenhum aplicativo conectado</h3><p>Os aplicativos que você autorizar aparecerão aqui, organizados por workspace.</p></div>}
      {Object.entries(groups).map(([accountId, items]) => <section key={accountId} className="oauth-workspace-group" aria-label={workspaceName(accountId)}>
        <div className="oauth-workspace-heading"><Icon id="icon-workspace" size="20" /><h3>{workspaceName(accountId)}</h3><span>{items.length} {items.length === 1 ? 'aplicativo' : 'aplicativos'}</span></div>
        {items.map(grant => <article className="oauth-app-card oauth-grant-card" key={grant.id}>
          <div className="oauth-card-heading"><AppIdentity application={grant.application} /><Button variant="info" size="sm" onClick={() => { setSelected(grant); setActionError(''); }}>Revogar acesso</Button></div>
          <p className="oauth-granted-date">Conectado em {new Date(grant.granted_at).toLocaleDateString('pt-BR')}</p>
          <ScopeList scopes={grant.scopes} />
        </article>)}
      </section>)}
    </>}
    {selected && <ConfirmAction title="Revogar acesso?" busy={busy} error={actionError} onCancel={() => !busy && setSelected(null)} onConfirm={revoke} confirmLabel="Revogar acesso">
      <p><strong>{selected.application?.name || 'Este aplicativo'}</strong> perderá imediatamente o acesso ao workspace <strong>{workspaceName(selected.account_id)}</strong>. Todas as sessões serão encerradas e as integrações em execução deixarão de funcionar.</p>
      <p>O aplicativo poderá solicitar uma nova autorização no futuro.</p>
    </ConfirmAction>}
  </Section>;
}
